import Vue from 'vue';
import axios from 'axios';
import Loading from 'quasar/src/plugins/Loading.js';;
export default {
  namespaced: true,
  state: {
    // 準備下次要 load 第幾頁
    nextPage: 0,
    // 是否已 load 到最後一筆了
    isLastPage: false,
    // 目前 load 出來的通知資料
    notificationData: [],
    // 是否已 load 完 API 請求(防止還沒執行完本次請求又發送一次新請求)
    isFinishLoad: false
  },
  getters: {
    // 取得通知的所有資訊
    getNotificationAllData: state => {
      return state.notificationData;
    },
    // 取得目前是否已 load 完 API 請求
    getNoticeLoadStatus: state => {
      return state.isFinishLoad;
    },

    // 取得目前是否為最後一筆資料
    getIsLastPage: state => {
      return state.isLastPage;
    }
  },
  mutations: {
    // 存下通知列表的陣列
    SET_NOTIFICATION_DATA(state, response) {
      let totalArray = state.notificationData.concat(response);
      Vue.set(state, 'notificationData', [...totalArray]);
    },

    // 重置通知列表的資料
    INIT_NOTIFICATION_DATA(state) {
      Vue.set(state, 'notificationData', []);
      state.nextPage = 0;
      state.isLastPage = false;
    },

    // 紀錄是否為最後一頁
    UPDATE_PAGE_INFO(state, data) {
      state.isLastPage = data;
      state.nextPage += 1;
    },

    // 更新 API loading 狀態
    UPDATE_NOTICE_LOAD_STATUS(state, data) {
      state.isFinishLoad = data;
    },

    // 已讀單篇通知
    READ_ONE_NOTIFY(state, notifyId) {
      // 用 id 去找 要改哪一個索引的 postWallData
      let idIndex = state.notificationData
        .map(item => {
          return item.NotificationId;
        })
        .indexOf(notifyId);
      state.notificationData[idIndex].Read = true;
    },

    // 已讀全部
    READ_ALL_NOTIFY(state) {
      state.notificationData.forEach(item => {
        item.Read = true;
      });
    }
  },
  actions: {
    // 取得鈴鐺內的通知資料
    getApiNotificationData(context) {
      context.commit('UPDATE_NOTICE_LOAD_STATUS', false);
      Loading.show();
      const api = `${process.env.VUE_APP_API_PATH}/showTopNotification`;
      const formData = new FormData();
      formData.append('PageIndex', context.state.nextPage);
      formData.append('ShowAmount', 20);
      axios
        .post(api, formData)
        .then(res => {
          context.commit('SET_NOTIFICATION_DATA', res.data.NotificationObjs);
          // 更新頁數資訊(紀錄是否為最後一筆，以及更新頁數 +1)
          context.commit('UPDATE_PAGE_INFO', res.data.IsLastPage);
          console.log(res.data);
          context.commit('UPDATE_NOTICE_LOAD_STATUS', true);
          Loading.hide();
        })
        .catch(error => {
          console.error(error);
          Loading.hide();
        });
    },

    // 更新查看通知中心的最後時間
    updateNotifyLastActivityTime(context) {
      const api = `${process.env.VUE_APP_API_PATH}/updateNotifyLastActivityTime`;
      axios
        .post(api)
        .then(res => {
          console.log('更新查看通知中心的最後時間:' + res.data.Status);
        })
        .catch(error => {
          console.error(error);
        });
    },

    // 通知訊息全部標為已讀
    readAllNotification(context) {
      const api = `${process.env.VUE_APP_API_PATH}/readAllNotification`;
      axios
        .post(api)
        .then(res => {
          console.log(res.data);
        })
        .catch(error => {
          console.error(error);
        });
    },

    // 已讀單篇通知
    readOnePost(context, data) {
      const api = `${process.env.VUE_APP_API_PATH}/forwardToPost/${data.postId}/${data.notificationId}`;
      axios
        .get(api)
        .then(res => {
          context.commit('READ_ONE_NOTIFY', data.notificationId);
          console.log(`已讀${data.notificationId}`);
        })
        .catch(error => {
          console.error(error);
        });
    }
  }
};
